import { render, staticRenderFns } from "./AddFakeFromExel.vue?vue&type=template&id=c75c51b0"
import script from "./AddFakeFromExel.vue?vue&type=script&lang=js"
export * from "./AddFakeFromExel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports